import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';
import React from 'react';
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';

import PublicRoute from './PublicRoute';
import ProtectedRoute from './ProtectedRoute';
import AppRoute from './AppRoute';

const Routes = () => {

	return (
		<RouterRoutes>
			<Route element={<ProtectedRoute />} path="/">
				<Route element={<Navigate replace to={AUTHENTICATED_ENTRY} />} path="/" />
				{protectedRoutes.map((route, index) => {
					return (
						<Route 
							element={
								<AppRoute
									component={route.component} 
									routeKey={route.key}
									{...route.meta} 
								/>
							} 
							key={route.key + index}
							path={route.path}
						/>
					)
				})}
				<Route element={<Navigate replace to="/" />} path="*" />
			</Route>
			<Route element={<PublicRoute />} path="/">
				{publicRoutes.map(route => {
					return (
						<Route 
							element={
								<AppRoute
									component={route.component} 
									routeKey={route.key}
									{...route.meta} 
								/>
							} 
							key={route.path}
							path={route.path}
						/ >
					)
				})}
			</Route>
		</RouterRoutes>
	)
}

export default Routes